import FontSizeChangeEvent from '@adobe-fonts/site/events/FontSizeChangeEvent.js';

export function registerEventHandlers(element) {
  element.addEventListener(
    FontSizeChangeEvent.EVENT_NAME, event => handleFontSizeChange(event, element));
}

/**
 * Change the text size of the parent element's children elements
 * that have data attribute `data-resizable-sample`
 *
 * @param {FontSizeChangeEvent} event
 * @param {HTMLElement} parent
 */
export function handleFontSizeChange(event, parent) {
  if (!(event instanceof FontSizeChangeEvent)) {
    return;
  }

  const fontSize = event.detail.fontSize;
  const samples = parent.querySelectorAll('[data-resizable-sample]');

  samples.forEach(function(sample) {
    sample.style.setProperty('font-size', `${fontSize}px`);
  });
}
